import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Tag, Popconfirm, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { storeAdminApi, storeApi } from '../../services/api';

const StoreAccounts = () => {
  const navigate = useCompanyNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [stores, setStores] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const params = { page, limit: pagination.pageSize };
      const res = await storeAdminApi.list(params);
      if (res.success) {
        setData(res.data.list);
        setPagination({
          ...pagination,
          current: page,
          total: res.data.pagination.total
        });
      }
    } catch (error) {
      message.error('获取门店账户列表失败');
    } finally {
      setLoading(false);
    }
  };

  const fetchStores = async () => {
    try {
      const res = await storeApi.list({ status: 1, limit: 100 });
      if (res.success) {
        setStores(res.data.list);
      }
    } catch (error) {
      console.error('获取门店列表失败', error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchStores();
  }, []);

  const handleDelete = async (id) => {
    try {
      await storeAdminApi.delete(id);
      message.success('删除成功');
      fetchData(pagination.current);
    } catch (error) {
      message.error('删除失败');
    }
  };

  const getStoreName = (storeId) => {
    const store = stores.find(s => s.id === storeId);
    return store ? store.name : '-';
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 60,
    },
    {
      title: '所属门店',
      dataIndex: 'store_id',
      render: (storeId) => getStoreName(storeId),
    },
    {
      title: '用户名',
      dataIndex: 'username',
    },
    {
      title: '真实姓名',
      dataIndex: 'real_name',
    },
    {
      title: '手机号',
      dataIndex: 'phone',
    },
    {
      title: '状态',
      dataIndex: 'is_active',
      render: (isActive) => (
        <Tag color={isActive === 1 ? 'green' : 'red'}>
          {isActive === 1 ? '启用' : '禁用'}
        </Tag>
      ),
    },
    {
      title: '最后登录',
      dataIndex: 'last_login_at',
      render: (text) => text ? new Date(text).toLocaleString('zh-CN') : '-',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => navigate(`/admin/store-accounts/${record.id}/edit`)}
          >
            编辑
          </Button>
          <Popconfirm
            title="确定删除该账户吗？"
            onConfirm={() => handleDelete(record.id)}
            okText="确定"
            cancelText="取消"
          >
            <Button type="link" danger icon={<DeleteOutlined />}>
              删除
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <Space>
          <Button
            icon={<ReloadOutlined />}
            onClick={() => fetchData(pagination.current)}
          >
            刷新
          </Button>
        </Space>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate('/admin/store-accounts/new')}
        >
          新增账户
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        pagination={{
          ...pagination,
          onChange: (page) => fetchData(page),
        }}
      />
    </div>
  );
};

export default StoreAccounts;
